
const Images = {
    logo: {
        path: '/logos/spoferan/spoferan-logo.png',
        ratio: 1173 / 210
    },
    favicon: {
        path: '/logos/spoferan/spoferan-icon.png',
        ratio: 988 / 869
    },
    companyLogo: {
        path: '/logos/spoferan/spoferan-icon.png',
        ratio: 988 / 869
    },
    resultastic: {
        logo: {
            path: '/logos/resultastic-logo.png',
            ratio: 3085 / 756
        },
        favicon: {
            path: '/logos/resultastic-icon.png',
            ratio: 800 / 800
        },
    },
    clubmanager: {
        logo: {
            path: '/logos/clubmanager/spoferan-clubmanager-logo.png',
            ratio: 1376 / 358
        },
        favicon: {
            path: '/logos/clubmanager/spoferan-clubmanager-icon.png',
            ratio: 1000 / 1000
        },
    }
}

export default Images;